"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _mergePromotionField = require("./mergePromotionField.helper");
var _mergeLookupField = require("./mergeLookupField.helper");
var _mergeInputField = require("./mergeInputField.shapes");
var _mergeInputField2 = require("./mergeInputField.helper");
var _label = _interopRequireDefault(require("./label/label.presenter"));
var _validation = _interopRequireDefault(require("./validation/validation.presenter"));
var _explanation = _interopRequireDefault(require("./explanation/explanation.presenter"));
var _inputContainer = _interopRequireDefault(require("./inputContainer/inputContainer.presenter"));
var _dropdownContainer = _interopRequireDefault(require("./dropdownContainer/dropdownContainer.presenter"));
var _temp;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var MergeInputField = (_temp = /*#__PURE__*/
function (_Component) {
  _inherits(MergeInputField, _Component);
  function MergeInputField() {
    var _this;
    _classCallCheck(this, MergeInputField);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MergeInputField).call(this));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function (_ref) {
      var prevSelectedItem = _ref.selectedItem,
        prevValue = _ref.value,
        wasMerging = _ref.isMerging;
      var _this$props = _this.props,
        selectedItem = _this$props.selectedItem,
        value = _this$props.value,
        isMerging = _this$props.isMerging,
        types = _this$props.types,
        onFetchPromotionFields = _this$props.onFetchPromotionFields,
        onFetchLookupFields = _this$props.onFetchLookupFields,
        onResetPaging = _this$props.onResetPaging,
        isPaginated = _this$props.isPaginated,
        uniqueID = _this$props.uniqueID;
      if ((0, _mergeInputField2.didValueChange)({
        prevValue: prevValue,
        value: value
      })) {
        isPaginated && onResetPaging(uniqueID);
        (0, _mergeInputField2.handleCursorPosition)({
          inputRef: _this.inputRef,
          value: value,
          types: types,
          wasMerging: wasMerging,
          isMerging: isMerging,
          prevSelectedItem: prevSelectedItem,
          selectedItem: selectedItem,
          prevValue: prevValue
        });
      }
      if ((0, _mergeInputField2.wasNewItemSelected)({
        prevSelectedItem: prevSelectedItem,
        selectedItem: selectedItem
      }) && !selectedItem.areFieldsFetching) {
        if ((0, _mergePromotionField.isPromotionType)({
          type: selectedItem.sourceType
        })) {
          onFetchPromotionFields(selectedItem.title);
        } else if ((0, _mergeLookupField.isLookupType)({
          type: selectedItem.sourceType
        })) {
          onFetchLookupFields(selectedItem.title);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setInputReference", function (reference) {
      _this.inputRef = reference;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setDropdownReference", function (reference) {
      _this.dropdownRef = reference;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPivotReferences", function (reference, index) {
      var _this$props2 = _this.props,
        highlightedIndex = _this$props2.highlightedIndex,
        pageSize = _this$props2.pageSize;
      switch (index) {
        case highlightedIndex + 1:
          _this.pivotReferences.arrow.down = reference;
          break;
        case highlightedIndex - 1:
          _this.pivotReferences.arrow.up = reference;
          break;
        case highlightedIndex + Math.floor(pageSize / 2):
          _this.pivotReferences.page.down = reference;
          break;
        case highlightedIndex - Math.floor(pageSize / 2):
          _this.pivotReferences.page.up = reference;
          break;
        default:
          break;
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
      var _this$props3 = _this.props,
        selectedItem = _this$props3.selectedItem,
        filter = _this$props3.filter,
        isMerging = _this$props3.isMerging,
        selectionSourceData = _this$props3.selectionSourceData,
        mergeSourceData = _this$props3.mergeSourceData,
        label = _this$props3.label,
        uniqueID = _this$props3.uniqueID,
        value = _this$props3.value,
        highlightedIndex = _this$props3.highlightedIndex,
        explanation = _this$props3.explanation,
        validation = _this$props3.validation,
        isReadOnly = _this$props3.isReadOnly,
        shouldShowResultsWhenBlank = _this$props3.shouldShowResultsWhenBlank,
        isSmall = _this$props3.isSmall,
        isRequired = _this$props3.isRequired,
        onLoadNextPage = _this$props3.onLoadNextPage,
        numberOfItemsInDropdown = _this$props3.numberOfItemsInDropdown,
        areResultsFetching = _this$props3.areResultsFetching,
        types = _this$props3.types;
      var _getSelected = (0, _mergeInputField2.getSelected)({
          selectedItem: selectedItem
        }),
        isPromotionSelected = _getSelected.isPromotionSelected,
        isLookupSelected = _getSelected.isLookupSelected,
        isLookupFieldSelected = _getSelected.isLookupFieldSelected,
        isSomethingSelected = _getSelected.isSomethingSelected;
      var dataForFiltering = (0, _mergeInputField2.getDataForFiltering)({
        isMerging: isMerging,
        mergeSourceData: mergeSourceData,
        selectionSourceData: selectionSourceData
      });
      var _getResultsData = (0, _mergeInputField2.getResultsData)({
          isReadOnly: isReadOnly,
          isSomethingSelected: isSomethingSelected,
          isPromotionSelected: isPromotionSelected,
          isLookupSelected: isLookupSelected,
          selectedItem: selectedItem,
          dataForFiltering: dataForFiltering,
          value: value,
          filter: filter,
          isMerging: isMerging,
          shouldShowResultsWhenBlank: shouldShowResultsWhenBlank,
          numberOfItemsInDropdown: numberOfItemsInDropdown,
          types: types
        }),
        results = _getResultsData.results,
        hasPromotionFieldResults = _getResultsData.hasPromotionFieldResults,
        hasLookupFieldResults = _getResultsData.hasLookupFieldResults,
        areResultsVisible = _getResultsData.areResultsVisible;
      var highlightedItem = (0, _mergeInputField2.getHighlightedItem)({
        areResultsVisible: areResultsVisible,
        results: results,
        highlightedIndex: highlightedIndex
      }) || null;
      var validationResults = (0, _mergeInputField2.findFailedValidation)({
        validation: validation,
        value: value
      });
      var isSpinnerVisible = areResultsFetching || selectedItem && selectedItem.areFieldsFetching;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('agillicMergeInputField', {
          small: isSmall
        }),
        "data-testid": uniqueID
      }, label && _react.default.createElement(_label.default, {
        label: label,
        uniqueID: uniqueID,
        isRequired: isRequired
      }), _react.default.createElement(_inputContainer.default, _extends({}, _this.props, {
        results: results,
        areResultsVisible: areResultsVisible,
        setReference: _this.setInputReference,
        highlightedItem: highlightedItem,
        isPromotionSelected: isPromotionSelected,
        isLookupSelected: isLookupSelected,
        isLookupFieldSelected: isLookupFieldSelected,
        isSomethingSelected: isSomethingSelected,
        dropdownRef: _this.dropdownRef,
        pivotReferences: _this.pivotReferences
      })), !isReadOnly && areResultsVisible && _react.default.createElement(_dropdownContainer.default, _extends({}, _this.props, {
        results: results,
        isSpinnerVisible: isSpinnerVisible,
        isPromotionSelected: isPromotionSelected,
        isLookupSelected: isLookupSelected,
        highlightedItem: highlightedItem,
        hasPromotionFieldResults: hasPromotionFieldResults,
        hasLookupFieldResults: hasLookupFieldResults,
        onScrollToBottom: onLoadNextPage,
        setDropdownReference: _this.setDropdownReference,
        setPivotReferences: _this.setPivotReferences
      })), validationResults !== undefined && explanation && _react.default.createElement(_explanation.default, {
        explanation: explanation
      }), validationResults && validationResults.message && _react.default.createElement(_validation.default, {
        message: validationResults.message
      }));
    });
    _this.pivotReferences = {
      arrow: {},
      page: {}
    };
    return _this;
  }
  return MergeInputField;
}(_react.Component), _temp);
MergeInputField.propTypes = {
  value: _propTypes.string.isRequired,
  uniqueID: _propTypes.string.isRequired,
  selectionSourceData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    data: (0, _propTypes.arrayOf)(_mergeInputField.dataShape).isRequired
  })).isRequired,
  selectedItem: (0, _propTypes.shape)({
    sourceType: _propTypes.string.isRequired
  }),
  types: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  locale: _mergeInputField.localeShape.isRequired,
  validation: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    criteria: _propTypes.func.isRequired,
    message: _propTypes.string.isRequired
  })),
  onUpdateFilter: _propTypes.func.isRequired,
  onUpdateValue: _propTypes.func.isRequired,
  onHighlightNext: _propTypes.func.isRequired,
  onHighlightPrevious: _propTypes.func.isRequired,
  onHighlightNextPage: _propTypes.func,
  onHighlightPrevPage: _propTypes.func,
  onClearHighlight: _propTypes.func.isRequired,
  onHighlightByIndex: _propTypes.func.isRequired,
  onSelect: _propTypes.func.isRequired,
  onMerging: _propTypes.func.isRequired,
  onChangeCursorPosition: _propTypes.func.isRequired,
  onDropdownVisible: _propTypes.func.isRequired,
  onFetchPromotionFields: _propTypes.func.isRequired,
  onFetchLookupFields: _propTypes.func.isRequired,
  label: _propTypes.string,
  filter: _propTypes.string,
  placeholder: _propTypes.string,
  instruction: _propTypes.string,
  explanation: _propTypes.string,
  mergeSourceData: (0, _propTypes.arrayOf)(_propTypes.object),
  highlightedIndex: _propTypes.number,
  isMerging: _propTypes.bool,
  isReadOnly: _propTypes.bool,
  hasMultipleLines: _propTypes.bool,
  shouldShowResultsWhenBlank: _propTypes.bool,
  isDisabled: _propTypes.bool,
  isSmall: _propTypes.bool,
  isRequired: _propTypes.bool,
  isPaginated: _propTypes.bool,
  pageSize: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _airbnbPropTypes.between)({
    gte: 5
  }), (0, _propTypes2.requiredBy)('pagination')]),
  onLoadNextPage: (0, _airbnbPropTypes.and)([_propTypes.func, (0, _propTypes2.requiredBy)('pagination')]),
  onResetPaging: (0, _airbnbPropTypes.and)([_propTypes.func, (0, _propTypes2.requiredBy)('pagination')]),
  numberOfItemsInDropdown: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _propTypes2.requiredBy)('pagination')]),
  areResultsFetching: _propTypes.bool
};
MergeInputField.defaultProps = {
  numberOfItemsInDropdown: 10,
  pageSize: 10
};
var _default = MergeInputField;
exports.default = _default;